import { getCompatibleChartsForMetric } from '@revelio/core';

import type { ChartType } from '../../PageConfigProvider/types/chart';
import type { MetricValues } from '../../PageConfigProvider/types/metric';
import { isSelectableChartType } from './is-selectable-chart-type';

// Filter section in the Chart builder panel
export const getIsFilterEnabled = ({
  chartType,
  metric,
  chartSupportsFilter,
}: {
  chartType?: ChartType;
  metric?: MetricValues;
  chartSupportsFilter: boolean;
}): boolean => {
  if (!isSelectableChartType(chartType)) return false;
  if (!chartSupportsFilter) return false;
  if (metric === 'td_users') return false;
  if (chartType === 'sankey') {
    return (
      metric !== undefined &&
      getCompatibleChartsForMetric(metric).includes('sankey')
    );
  }
  return true;
};
